<template>
<div>
    <div class="tab-sync">{{$t('language.popup.selectSync')}}</div>
    <div class="tab-sync-box">
        <div class="page-one" v-if="realTimeShow" >
            <selects ref="selectrealTime" :widthVal="260" :selectOption="realTimeSelectOption" :placeholder="realTimeSelectValue" @changeOption="onChangeOptionRealTime" @deleteSelectOption="deleteSelectOptionRealTime" style="margin:0px !important;float:left;"></selects>
        </div>
        <div  :class="[realTimeShow?'page-two':'page-one']">
            <selects ref="selectOne" :widthVal="260" :selectOption="selectOption" :placeholder="selectValue" @changeOption="onChangeOptionOne" @deleteSelectOption="deleteSelectOptionOne" style="margin:0px !important;float:left;"></selects>
        </div>
        <!-- 显示第三项 -->
        <div  :class="realTimeShow&&pageLanguage.includes($i18n.locale)?'page-bottom':'page-two'">
            <selects ref="selectTwo" v-show="selectTwoShow" :widthVal="260" :selectOption="selectOptionTwo" :placeholder="selectValueTwo" @changeOption="onChangeOptionTwo" style="margin:0px !important;float:right;" @deleteSelectOption="deleteSelectOptionTwo"></selects>
        </div>
    </div>
    <div class="des-tip">
        {{$t('language.popup.tipsFor')}} {{tipsTitle}}:
    </div>
    <div class="des-tip-content">
        {{tipsDesc}}
    </div>
    <div class="footer-tip">
        <div class="icon-util  tip-check" :class="[isActive==false?'nocheck-small-blue':'check-small']" @click="tipCheck()"></div>
        <span class="check-item-position" style="margin-right:5Px;" @click="tipCheck()">{{$t('language.popup.automaRename')}}</span>
        <div class="icon-util question-mark question-position">
            <div :class="$i18n.locale=='france'?'prompt-right':'prompt-tip'">{{$t('language.popup.optionsPrompt')}}</div>
        </div>
    </div>
</div>
</template>

<script>
import selects from "@/components/common/select/cloud_select";
import commonstate from '@/js/constant.js';
export default {
  components: {
    selects
  },
  data: function () {
    return {
      pageLanguage: ['deutsch', 'france', 'portuguese', 'spanish', 'italian', 'nederlands',],//会导致界面错乱的语言
      selectTwoShow: true,
      selectOption: [{
        name: this.$t('language.popup.twowaySync'),
        id: 1
      }],
      realTimeTypeSelectOption:[
           {
          name:this.$t('language.popup.twowaySync'),
          id: 1
          },
      ],
      selectOptinAll: [
        {
          name: this.$t('language.popup.onewaySync'),
          id: 0

        },
        {
          name: this.$t('language.popup.twowaySync'),
          id: 1
        }
      ],
      realTimeSelectOption: [{
        name: this.$t('language.cloudSync.normalSync'),
        id: 1
      }],
      selectValue: this.$t('language.popup.onewaySync'),
      realTimeSelectValue: this.$t('language.cloudSync.realTimeSync'),
      widthVal: 260,
      selectOptionTwo: [{
        name: this.$t('language.popup.mirrorSync'),
        icon: true,
        id: 1
      },
      {
        name: this.$t('language.popup.moveSync'),
        icon: true,
        id: 2
      },
      {
        name: this.$t('language.popup.cmuSync'),
        icon: true,
        id: 3
      },
      {
        name: this.$t('language.popup.updateSync'),
        icon: true,
        id: 4
      },
      {
        name: this.$t('language.popup.increSync'),
        icon: true,
        id: 5
      },
      {
        name: this.$t('language.popup.fullSync'),
        icon: true,
        id: 6
      }
      ],
      selectOptionTwoAll: [
        {
        name: this.$t('language.popup.simpleSync'),
        icon: true,
        id: 0
      },{
        name: this.$t('language.popup.mirrorSync'),
        icon: true,
        id: 1
      },
      {
        name: this.$t('language.popup.moveSync'),
        icon: true,
        id: 2
      },
      {
        name: this.$t('language.popup.cmuSync'),
        icon: true,
        id: 3
      },
      {
        name: this.$t('language.popup.updateSync'),
        icon: true,
        id: 4
      },
      {
        name: this.$t('language.popup.increSync'),
        icon: true,
        id: 5
      },
      {
        name: this.$t('language.popup.fullSync'),
        icon: true,
        id: 6
      }
      ],
      selectOptionThree: [
        {
          name: this.$t('language.popup.simpleSync'),
          icon: false,
          id: 0
        },
        {
          name: this.$t('language.popup.mirrorSync'),
          icon: true,
          id: 1
        },
        {
          name: this.$t('language.popup.moveSync'),
          icon: true,
          id: 2
        },
        {
          name: this.$t('language.popup.cmuSync'),
          icon: true,
          id: 3
        },
      ],
      selectOptionAllTwo: '',
      selectOptionAllOne: '',
      selectValueTwo: this.$t('language.popup.simpleSync'),
      isActive: true,
      promptShow: false,
      selectTwoValue: '',
      selectOneValue: '',
      oldSelectOneValue: this.$t('language.popup.onewaySync'),
      oldSelectTwoValue: this.$t('language.popup.simpleSync'),
      oldIsActive: true,
      tipsTitle: this.$t('language.popup.simpleSync'),
      tipsDesc: this.$t('language.popup.simpleSyncTip'),
      deleteOptionTwo: null,
      deleteOptionOne: null,
      realTimeShow: true,
      realTimeSelectOptionAll: [
        {
          name: this.$t('language.cloudSync.realTimeSync'),
          icon: false,
          id: 0
        },
        {
          name: this.$t('language.cloudSync.normalSync'),
          icon: false,
          id: 1
        }],
      realTimeMode: true,//用于辨别是否是即时同步模式，默认为真
      listNormalOpen:false,//标识是否是任务列表多目标普通同步打开的普通同步option
    }
  },
  mounted () {
    this.selectOptionAllTwo = Object.assign([], this.selectOptionTwo);
    this.selectOptionAllOne = Object.assign([], this.selectOption);
    this.selectOptionAllTwo.push({
      id: 0,
      icon: false,
      name: this.$t('language.popup.simpleSync')
    });
    this.selectOptionAllOne.push({
      id: 0,
      icon: false,
      name: this.$t('language.popup.onewaySync')
    });
    this.$refs.selectOne.widthValue = 260;
    this.$refs.selectTwo.widthValue = 260;
  },
  methods: {
    //更改第二个下拉框的选项
    onChangeOptionOne (newValue) {
      let that=this;
      this.selectOption = Object.assign([], this.selectOptionAllOne);
      switch (newValue.replace(/^\s+|\s+$/g, "")) {
        case this.$t('language.popup.twowaySync').replace(/^\s+|\s+$/g, ""):
          this.selectTwoShow = false;
          this.tipsTitle = this.$t('language.popup.twowaySync');
          this.tipsDesc = this.$t('language.popup.twowaySyncTip');
          this.$parent.$parent.$parent.options.way = 20;
          this.selectOption.splice(0, 1);
           if (!this.realTimeMode) {
          this.selectOption[0].name=this.$t('language.popup.onewaySync');
           }else{
          this.selectOption[0].name=this.$t('language.cloudSync.oneWaySimple');
           }
          this.$forceUpdate();
          break;
        default:
          this.selectTwoShow = true;
          this.$parent.$parent.$parent.options.way = 10;
          this.tipsTitle = this.$t('language.popup.simpleSync');
          this.tipsDesc = this.$t('language.popup.simpleSyncTip');
          if (!this.realTimeMode) {
            this.selectOption.splice(1, 1);
          } else {//如果是即时同步
            this.selectOption = [  {
          name:this.$t('language.popup.twowaySync'),
          id: 1
          }];//即时同步显示选项;
            this.selectTwoShow=false;//不显示第三项
             this.$nextTick(() => {
            that.$refs.selectOne.setInputWidth();
          });
          }
          break;
      }
    },
    //第一个下拉选项的
    onChangeOptionRealTime (newValue) {
      let that = this;
      this.realTimeSelectOption = Object.assign([], this.realTimeSelectOptionAll);
      switch (newValue.replace(/^\s+|\s+$/g, "")) {
        case this.$t('language.cloudSync.realTimeSync').replace(/^\s+|\s+$/g, ""):
          this.realTimeSelectOption.splice(0, 1);
          this.$parent.$parent.$parent.$parent.scheduleShow = false;
        if(this.$parent.$parent.$parent.options.way == 10){
          this.selectValue = this.$t('language.cloudSync.oneWaySimple');
          this.$refs.selectOne.currentValue =this.$t('language.cloudSync.oneWaySimple');
        }
         if(this.$parent.$parent.$parent.options.way == 20){
           this.selectOption = [{
            name: this.$t('language.cloudSync.oneWaySimple'),
            id: 1
          }];
        }
          this.selectTwoShow=false;
          this.$refs.selectOne.$forceUpdate();
          this.$forceUpdate();
          this.$nextTick(() => {
            that.$refs.selectTwo.setInputWidth();
            that.$refs.selectOne.setInputWidth();
          });
          this.realTimeMode = true;
          break;
        default://如果用户选择的是简单同步或者没选
          if(newValue== this.$t('language.cloudSync.normalSync').replace(/^\s+|\s+$/g, "")){
               this.realTimeMode = false;
          }
          if((this.$parent.$parent.$parent.options.way && this.$parent.$parent.$parent.options.way!=20) || !this.$parent.$parent.$parent.options.way){
          this.selectValue = this.$t('language.popup.onewaySync');
          this.$refs.selectOne.currentValue =this.$t('language.popup.onewaySync');
          this.selectTwoShow=true;
          this.$parent.$parent.$parent.$parent.scheduleShow = true;
          this.realTimeSelectOption.splice(1, 1);
          this.selectOption = [{
            name: this.$t('language.popup.twowaySync'),
            id: 1
          }];
            this.selectOptionTwo = Object.assign([],this.selectOptionTwoAll);
            this.selectOptionTwo.splice(0,1);
            if(this.$parent.$parent.$parent.options.way==10 || !this.$parent.$parent.$parent.options.way){
            this.selectValueTwo = this.$t('language.popup.simpleSync');
            this.$refs.selectTwo.currentValue = this.$t('language.popup.simpleSync');
            }
          this.$nextTick(() => {
            that.$refs.selectTwo.setInputWidth();
          });
          this.realTimeMode = false;
          break;
          }else{//如果用户已选择双向同步
           this.selectOption = [{
            name: this.$t('language.popup.onewaySync'),
            id: 0
             }];
            this.selectTwoShow=false;
              this.$nextTick(() => {
             that.$refs.selectOne.setInputWidth();
             });
            this.realTimeSelectOption=[{ name: this.$t('language.cloudSync.realTimeSync'),id: 0}];
            if(this.$parent.$parent.$parent.options.way==20){
             this.selectOptionTwo = Object.assign([],this.selectOptionTwoAll);
             this.selectOptionTwo.splice(0,1);  
            }
          }
      }
    },
    //更改第三个下拉框的选项
    onChangeOptionTwo (newValue) {
      let that = this;
      if (!this.realTimeMode) {
        this.selectOptionTwo = Object.assign([], this.selectOptionAllTwo);
      } else {
        this.selectOptionTwo = Object.assign([], this.selectOptionThree);
      }
      switch (newValue.replace(/^\s+|\s+$/g, "")) {
        case this.$t('language.popup.simpleSync').replace(/^\s+|\s+$/g, ""):
          this.tipsTitle = this.$t('language.popup.simpleSync');
          this.tipsDesc = this.$t('language.popup.simpleSyncTip');
          this.$parent.$parent.$parent.options.way = 10;
          if (this.realTimeMode) {
            this.selectOptionTwo.splice(0, 1);
            this.$nextTick(() => {
              that.$refs.selectTwo.setInputWidth();
            });
            break;
          }
          this.selectOptionTwo.splice(6, 1);
          break;
        case this.$t('language.popup.mirrorSync').replace(/^\s+|\s+$/g, ""):
          this.tipsTitle = this.$t('language.popup.mirrorSync');
          this.tipsDesc = this.$t('language.popup.mirrorSyncTip');
          this.$parent.$parent.$parent.options.way = 11;
          if (this.realTimeMode) {
            this.selectOptionTwo.splice(1, 1);
            this.$nextTick(() => {
              that.$refs.selectTwo.setInputWidth();
            });
            break;
          }
          this.selectOptionTwo.splice(0, 1);
          break;
        case this.$t('language.popup.moveSync').replace(/^\s+|\s+$/g, ""):
          this.tipsTitle = this.$t('language.popup.moveSync');
          this.tipsDesc = this.$t('language.popup.moveSyncTip');
          this.$parent.$parent.$parent.options.way = 12;
          if (this.realTimeMode) {
            this.selectOptionTwo.splice(2, 1);
            this.$nextTick(() => {
              that.$refs.selectTwo.setInputWidth();
            });
            break;
          }
          this.selectOptionTwo.splice(1, 1);
          break;
        case this.$t('language.popup.cmuSync').replace(/^\s+|\s+$/g, ""):
          this.tipsTitle = this.$t('language.popup.cmuSync');
          this.tipsDesc = this.$t('language.popup.cmuSyncTip');
          this.$parent.$parent.$parent.options.way = 13;
          if (this.realTimeMode) {
            this.selectOptionTwo.splice(3, 1);
            this.$nextTick(() => {
              that.$refs.selectTwo.setInputWidth();
            });
            break;
          }
          this.selectOptionTwo.splice(2, 1);
          break;
        case this.$t('language.popup.updateSync').replace(/^\s+|\s+$/g, ""):
          this.tipsTitle = this.$t('language.popup.updateSync');
          this.tipsDesc = this.$t('language.popup.updateSyncTip');
          this.$parent.$parent.$parent.options.way = 14;
          this.selectOptionTwo.splice(3, 1);
          break;
        case this.$t('language.popup.increSync').replace(/^\s+|\s+$/g, ""):
          this.tipsTitle = this.$t('language.popup.increSync');
          this.tipsDesc = this.$t('language.popup.increSyncTip');
          this.$parent.$parent.$parent.options.way = 15;
          this.selectOptionTwo.splice(4, 1);
          break;
        case this.$t('language.popup.fullSync').replace(/^\s+|\s+$/g, ""):
          this.tipsTitle = this.$t('language.popup.fullSync');
          this.tipsDesc = this.$t('language.popup.fullSyncTip');
          this.$parent.$parent.$parent.options.way = 16;
          this.selectOptionTwo.splice(5, 1);
          break;
        default:
          this.tipsTitle = this.$t('language.popup.simpleSync');
          this.tipsDesc = this.$t('language.popup.simpleSyncTip');
          this.$parent.$parent.$parent.options.way = 10;
          this.selectOptionTwo.splice(6, 1);
          break;
      }
    },
    deleteSelectOptionTwo (index) {
      if (this.deleteOptionTwo && this.deleteOptionTwo.length > 0) {
        this.selectOptionTwo.splice(this.deleteOptionTwo[0].id, 0, {
          id: this.deleteOptionTwo[0].id,
          icon: this.deleteOptionTwo[0].icon,
          name: this.deleteOptionTwo[0].name
        });
        if (this.deleteOptionTwo[0].id <= index) {
          this.deleteOptionTwo = this.selectOptionTwo.splice(index + 1, 1);
        } else {
          this.deleteOptionTwo = this.selectOptionTwo.splice(index, 1);
        }
      } else {
        this.selectOptionTwo.splice(0, 0, {
          id: 0,
          icon: false,
          name: this.$t('language.popup.simpleSync')
        });
        this.deleteOptionTwo = this.selectOptionTwo.splice(index + 1, 1);
      }
    },
    deleteSelectOptionOne (index) {
      if (this.deleteOptionOne && this.deleteOptionOne.length > 0) {
        //在数组起始位置插入数据
        this.selectOption.splice(0, 0, {
          id: this.deleteOptionOne[0].id,
          name: this.deleteOptionOne[0].name
        });
        //删除后一位置另一个数
        this.deleteOptionOne = this.selectOption.splice(1, 1);
      } else {
        //在数组起始位置插入数据
        this.selectOption.splice(0, 0, {
          name: this.$t('language.popup.onewaySync'),
          id: 0
        });
        //删除后一位置另一个数
        this.deleteOptionOne = this.selectOption.splice(1, 1);
      }
    },
    deleteSelectOptionRealTime (index) {
      if (this.deleteOption && this.deleteOption.length > 0) {
        this.realTimeSelectOption.splice(this.deleteOption[0].id, 0, {
          id: this.deleteOption[0].id,
          icon: this.deleteOption[0].icon,
          name: this.deleteOption[0].name
        });
      } else {
        this.realTimeSelectOption.splice(0, 0, {
          id: 0,
          icon: false,
          name: 'Normal Sync'
        });
        this.deleteOption = this.realTimeSelectOption.splice(index + 1, 1);
      }
    },
    tipCheck () {
      this.isActive = !this.isActive;
      if (this.isActive) {
        this.$parent.$parent.$parent.options.isChar = 1;
      } else {
        this.$parent.$parent.$parent.options.isChar = 0;
      }
    },
  }
}
</script>

<style>
.page-bottom {
  float: left;
  margin-top: 7px;
}
.prompt-tip-position {
  top: -70px;
  /*no*/
  left: -390px;
  /*no*/
}

.footer-tip {
  width: 100%;
  position: relative;
}

.tab-sync-box {
  width: 100%;
  height: 40px;
  /*no*/
  margin-bottom: 40px;
  /*no*/
}

.tab-sync {
  margin-bottom: 10px;
  /*no*/
}

.des-tip {
  width: 100%;
  font-size: 14px;
  /*no*/
  color: #323b4c;
  font-weight: bold;
  margin-bottom: 15px;
  /*no*/
  float: left;
  margin-top: 15Px;
}

.des-tip-content {
  width: 100%;
  line-height: 25px;
  /*no*/
  margin-bottom: 35px;
  /*no*/
}
</style>



// WEBPACK FOOTER //
// src/components/common/tabs/tabs_transfer_options/tab_sync.vue